<div class="container-fluid py-4"> 
  <div class="row justify-content-center">
    <!-- Profile Card -->
    <div class="col-lg-6 col-md-8 col-sm-12">
      <div class="card p-4 border-0">
        
        <!-- Responsive Profile Section -->
        <div class="d-flex flex-column flex-sm-row align-items-center gap-3 w-100">
          
          <!-- Profile Image -->
          <img [src]="data.data[0]?.profilePicture || defaultProfileImage" 
               alt="Profile" 
               class="rounded-circle profile-img cursor-pointer border border-3 border-primary"
               width="150" height="150"
               data-bs-toggle="modal" data-bs-target="#imageModal"
               (click)="openModal(data.data[0]?.profilePicture)">
          
          <!-- Profile Info -->
          <div class="flex-grow-1 text-center text-sm-start w-100">
            <h4 class="mb-1 fw-bold mx-3 fs-1">{{ data.data[0]?.name }}</h4>
            <p class="text-primary fw-semibold mx-4">{{ data.data[0]?.type }}</p>
            <p class="mb-1 w-auto w-sm-auto d-flex align-items-center mx-2"><strong class="mx-1">📞 Mobile:</strong>{{ data.data[0]?.mobile }}</p>
            <p class="mb-1 w-auto w-sm-auto d-flex align-items-center mx-2"><strong class="mx-1">📧 Email:</strong> {{ data.data[0]?.email }}</p>
            <p class="mb-1 w-auto w-sm-auto d-flex align-items-center mx-2"><strong class="mx-1">📍 Location:</strong> {{ data.data[0]?.address?.location }}</p>
          </div>
        </div>

                         
        
        <!-- Tab Buttons -->
        <div class="d-flex mt-3 w-100">
          <button class="btn btn-outline-primary flex-fill fw-semibold mx-1" (click)="setActiveTab('posts')">
            Posts
          </button>
          <button class="btn btn-outline-primary flex-fill fw-semibold mx-1" (click)="setActiveTab('issues')">
            Issues
          </button>
          <button class="btn btn-outline-primary flex-fill fw-semibold mx-1" (click)="setActiveTab('solved')">
            Solved Issues
          </button>
          <button class="btn btn-outline-primary flex-fill fw-semibold mx-1" (click)="setActiveTab('social')">
            Social Activity
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal for Full Image View -->
  <div class="modal fade" id="imageModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ data.data[0]?.name }}'s Profile Picture</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
        </div>
        <div class="modal-body text-center">
          <img [src]="selectedImage" class="img-fluid rounded shadow w-100">
        </div>
      </div>
    </div>
  </div>
</div>
